import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ChevronLeftIcon } from "@radix-ui/react-icons"

const ReturnButton = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/');
  };

  return (
    <Button variant="outline" size="icon" onClick={handleButtonClick}>
      <ChevronLeftIcon className="h-4 w-4" />
    </Button>
  );
};

export default ReturnButton;